import React from 'react';

interface Props {
  size?: number;
}

const IFrame = ({ size = 41 }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x=".67" y=".5" width="40" height="40" rx="2.95" fill="#59C3C3" />
    <path
      d="M.67 3.45v34.1a2.95 2.95 0 0 0 2.95 2.95h13.2l6.92-40H3.62A2.95 2.95 0 0 0 .67 3.45Z"
      fill="#46AEAE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.08 28.62a1.15 1.15 0 0 1 0-1.63l6.1-6.1-6.1-6.11a1.15 1.15 0 0 1 1.63-1.63l6.93 6.92c.45.45.45 1.18 0 1.63l-6.93 6.92c-.45.45-1.18.45-1.63 0Zm-6.83-15.48c.45.46.45 1.19 0 1.64l-6.1 6.1 6.1 6.11a1.15 1.15 0 0 1-1.63 1.63L8.7 21.7a1.15 1.15 0 0 1 0-1.63l6.92-6.93a1.15 1.15 0 0 1 1.63 0Z"
      fill="#fff"
    />
  </svg>
);

export default IFrame;
